import type { UiSchema } from '@rjsf/utils'
import { isPlainObject, type JsonObject } from './mergePatch'

const ZOCKS_UI_KEY_MAP: Record<string, string> = {
  widget: 'ui:widget',
  placeholder: 'ui:placeholder',
  help: 'ui:help',
}

const mergeUiSchemaNodes = (a: JsonObject, b: JsonObject): JsonObject => {
  const result: JsonObject = { ...a }
  for (const [key, value] of Object.entries(b)) {
    const existing = result[key]
    result[key] = isPlainObject(existing) && isPlainObject(value) ? mergeUiSchemaNodes(existing, value) : value
  }
  return result
}

const buildNode = (schema: unknown): JsonObject => {
  if (!isPlainObject(schema)) {
    return {}
  }

  let node: JsonObject = {}

  if (isPlainObject(schema.zocksUi)) {
    for (const [key, value] of Object.entries(schema.zocksUi)) {
      const uiKey = ZOCKS_UI_KEY_MAP[key]
      if (uiKey) {
        node[uiKey] = value
      }
    }
  }

  if (isPlainObject(schema.zocksReference)) {
    node['ui:widget'] = 'zocksReference'
  }

  if (isPlainObject(schema.properties)) {
    for (const [key, propertySchema] of Object.entries(schema.properties)) {
      const child = buildNode(propertySchema)
      if (Object.keys(child).length > 0) {
        node[key] = child
      }
    }
  }

  if (schema.items !== undefined) {
    const child = buildNode(schema.items)
    if (Object.keys(child).length > 0) {
      node.items = child
    }
  }

  for (const branchKey of ['then', 'else'] as const) {
    if (schema[branchKey] !== undefined) {
      node = mergeUiSchemaNodes(node, buildNode(schema[branchKey]))
    }
  }

  for (const branchesKey of ['allOf', 'oneOf', 'anyOf'] as const) {
    if (Array.isArray(schema[branchesKey])) {
      for (const branch of schema[branchesKey]) {
        node = mergeUiSchemaNodes(node, buildNode(branch))
      }
    }
  }

  return node
}

export const buildUiSchema = (schema: unknown): UiSchema => buildNode(schema) as UiSchema
